import React from 'react'
import { Button } from 'antd'
import './Button.styl'

const SbButton = ({ className, ...props }) => <Button className={`sb-button ${className || ''}`} {...props} />
export default SbButton
